package org.dronda.app.web.client

import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import org.dronda.app.web.repository.AuthRepository
import org.dronda.application.config.BuildKonfig
import org.dronda.lib.ktor.client.plugins.BearerAuthPlugin

fun buildClient(
    authRepository: AuthRepository
) = HttpClient(Js) {
    install(ContentNegotiation) {
        json(Json { ignoreUnknownKeys = true })
    }

    install(BearerAuthPlugin) {
        authorizeRequest = {
            authRepository.getAuthTokens()?.token
        }
        this.refreshToken = {
            authRepository.tryRefreshTokens()
        }
    }
    defaultRequest {
        url(BuildKonfig.apiUrl)
    }
}